var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg17(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 15.0715H5.09522C5.09522 16.0971 5.92671 16.9287 6.95236 16.9287H8.8095H24.9048C25.9304 16.9287 26.7619 16.0971 26.7619 15.0715H29.8571V26.5238C29.8571 27.8915 28.7485 29.0001 27.3809 29.0001H14.3809H4.47621C3.10863 29.0001 2 27.8915 2 26.5238V15.0715ZM6.1786 23.4285C5.40934 23.4285 4.78574 24.0521 4.78574 24.8214C4.78574 25.5906 5.40934 26.2142 6.1786 26.2142C6.94785 26.2142 7.57145 25.5906 7.57145 24.8214C7.57145 24.0521 6.94785 23.4285 6.1786 23.4285Z",
    fill: "#FAB215"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7857 3H8.5V15.0714H14.0714H23.3571V8.57143H17.7857V3Z",
    fill: "url(#paint0_linear_887_4812)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7857 3V8.57143H23.3571L17.7857 3Z",
    fill: "#FAB215"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_887_4812",
    x1: 9.89286,
    y1: 4.39286,
    x2: 18.25,
    y2: 16.9286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB215",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB215",
    stopOpacity: 0.25
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg17);
export default __webpack_public_path__ + "static/media/17.46ad2c0896528d9ad62a4703ba7ee45d.svg";
export { ForwardRef as ReactComponent };